import { TApplicationState } from '../../types/redux';

export function getNearbyNewbuildingsMapUrl(state: TApplicationState) {
  return state.newbuilding.nearbyNewbuildingsMapUrl;
}
